import { PlatformInfoDTO } from "../domain/models/dto/PlatformInfoDTO";
import { ApiServiceImpl, createAsyncThunkFactory } from "./ApiServiceImpl";

export class PlatformInfoServiceImpl extends ApiServiceImpl {
    private constructor() {
        super();
    }

    static getPlatformInfoThunk = createAsyncThunkFactory<
        PlatformInfoDTO,
        void
    >("PlatformInfoServiceImpl.getPlatformInfo", async () => {
        return this.get("/api/v1/platform-info", undefined, true);
    });
}
